export default __webpack_public_path__ + "static/media/dark.ee3e440d.svg";